import { render, staticRenderFns } from "./addQuestionVipBank.vue?vue&type=template&id=15ca27b9&scoped=true&"
import script from "./addQuestionVipBank.vue?vue&type=script&lang=js&"
export * from "./addQuestionVipBank.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionVipBank.vue?vue&type=style&index=0&id=15ca27b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca27b9",
  null
  
)

export default component.exports